<template>
  <regular-tables-template
    :headers="headersResultsByUniverses"
    :datas="resultsByUniverses"
    :title="title"
    :is-loading="isLoading"
    :has-error="hasError"
    :error-msg="errorMsg"
    :error-empty="errorEmpty"
    :color="color"
    small-icon
  />
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import RegularTablesTemplate from './templates/RegularTablesTemplate.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'ResultsByUniverses',

    /* Sous-composants utilisés par ce composant */
    components: {
      RegularTablesTemplate,
    },

    /* Paramètres */
    props: {
      request: {
        type: String,
        default: '',
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      errorMsg: {
        type: String,
        default: '',
      },
      errorEmpty: {
        type: Object,
        default: function () {
          return {
            msg: 'Un problème est survenu.',
            icon: 'mdi-alert-rhombus-outline',
            color: 'error',
          }
        },
      },
      color: {
        type: String,
        default: 'primary',
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        title: 'Résultats par univers',
        isLoading: true,
        hasError: false,
        resultsByUniverses: [],
        headersResultsByUniverses: [
          '#',
          'Univers',
          'Nombre de réponses',
          'Note',
        ],
      }
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      request: function (newVal) {
        this.fetchResultsByUniverses()
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchResultsByUniverses()
    },

    /* Fonctions internes */
    methods: {
      // Récuperation des données Résultats par Univers
      fetchResultsByUniverses: function () {
        this.isLoading = true
        this.$Auth.httpRequest(
          'get',
          'api/dashboard/tables/resultsByUniverses' + this.request,
        )
          .then(response => {
            if (
              !Array.isArray(response.data) ||
              (Array.isArray(response.data) && response.data.length < 1)
            ) {
              this.resultsByUniverses = []
            } else {
              this.resultsByUniverses = response.data
            }
            this.hasError = false
          })
          .catch((error) => {
            this.hasError = true
            if (this.isAdmin) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
            this.$emit('set-error', error)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
    },
  }
</script>
